'use strict';/* global define */define('modules/my-organization/config',['require','exports','module','./states/my-organization/index'],function(require,exports,module){'use strict';// @ngInject
var config=function config($stateProvider){$stateProvider.state('app.both.myOrganization',require('./states/my-organization/index'));};
config.$inject = ["$stateProvider"];module.exports=config;});
